import { Component, Input } from '@angular/core';
import { IntegradorService } from '../../services/integrador.service';
import { Processamento } from '../../types/Processamento.type';

@Component({
  selector: 'app-listarprocessos',
  templateUrl: './listarprocessos.component.html',
  styleUrl: './listarprocessos.component.css'
})
export class ListarprocessosComponent {

  @Input() processos!: string

  processamentos: Processamento[] = []
  loading: boolean = false;
  totalRecords: number = 0;

  constructor(private integradorService: IntegradorService){}

  carregaProcessamento(event: any){
    this.loading = true

    const sortDirection = event.sortOrder === 1 ? 'asc' : 'desc';

    let page: number =  0;

    if(!isNaN(event.first / event.rows)) page = event.first / event.rows

    this.integradorService.getProcessamentos(page | 0,
      event.rows | 100,
      event.sortField,
      sortDirection,
      this.processos).subscribe(
        (data) => {
          this.processamentos = data.content;
          this.totalRecords = data.totalElements;
          this.loading = false;
        }
      )
  }
}
